import BrokerTable from 'components/features/broker-table';
import HomeLayout from 'layouts/home-layout';

function BrokerRecords() {
  return (
    <HomeLayout title="Broker Records">
      <BrokerTable />
    </HomeLayout>
  );
}

export default BrokerRecords;
